<template>

  <b-modal 
    id="form-challenge" 
    modal-class='form form-challenge'
    modal-footer="hide"
    scrollable
    centered 
    :title="theTitle"
    >
     
    <div class="form form__addChallenge">
      <b-overlay
        id="overlay-challenge"
        :show="showMe"
        rounded="sm"
        variant="white"
        opacity='0.8'
        blur="2px"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small        
      >     

        <!-- <b-form @submit="onSubmit" @reset="onReset"> -->
        <b-form>
            <!-- TITLE -->
            <b-form-group
              id="input-group-1"
              :label="formContent.formTitle"
              label-for="challenge-title"
            >
              <b-form-input
                id="challenge-title"
                v-model="form.title"
                required
                :state="nameState"
                :placeholder="formContent.formTitlePlaceholder"
              ></b-form-input>
            </b-form-group>   

            <!-- REFERENCE -->
            <b-form-group
              id="input-group-2"
              :label="formContent.formRef"
              label-for="challenge-ref"
            >
            <div class="btnGroup" id="challenge-ref">
              <b-button class="btn-modal vie" :data-value="formContent.formRefBtOne" @click="toggleButtons">{{formContent.formRefBtOne}}</b-button>
              <b-button class="btn-modal dommage " :data-value="formContent.formRefBtTwo" @click="toggleButtons">{{formContent.formRefBtTwo}}</b-button>
              <b-button class="btn-modal qualite" data-value="qualite" @click="toggleButtons">{{formContent.formRefBtThree}}</b-button>
            </div>
            </b-form-group>  


            <!-- CATEGORIE & CRITERIA -->
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group
                  id="input-group-3"
                  :label="formContent.formCat"
                  label-for="challenge-select"
                >
                <div class="select__wrapper">
                  <CustomSelect
                    :options="cat"
                    :default.sync="optionsDefault"
                    class="select"
                    :class="{disabled:catDisabled}"
                    @input="displayToKey($event)"
                  />      
                </div>

                </b-form-group>  
              </b-col>
              <b-col sm="12" lg="6">
                <b-form-group
                  id="input-group-4"
                  :label="formContent.formCriteria"
                  label-for="challenge-criteria"
                >
                <div class="select__wrapper">
                  <CustomSelect
                    :options="criteria"
                    :default.sync="criteriaDefault"
                    class="select"
                    :class="{disabled:criteriaDisabled}"
                    @input="displayCriteria($event)"
                  />      
                </div>

                </b-form-group>  
              </b-col>
            </b-row>


            <!-- DATES START & END -->
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group
                  id="input-group-5"
                  :label="formContent.formStart"
                  label-for="challenge-start"
                >
                  <b-form-datepicker 
                  id="challenge-start" 
                  v-model="form.startDate" 
                  :placeholder="formContent.formDatePlaceholder"
                  :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                  required
                  :state="stateStartDate"                  
                  >
                  </b-form-datepicker>
                </b-form-group>  
              </b-col>
              <b-col sm="12" lg="6">
                <b-form-group
                  id="input-group-6"
                  :label="formContent.formEnd"
                  label-for="challenge-end"
                >
                  <b-form-datepicker 
                  id="challenge-end" 
                  v-model="form.endDate" 
                  :placeholder="formContent.formDatePlaceholder"
                  :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                  required
                  :state="stateEndDate"                    
                  >
                  </b-form-datepicker>
                </b-form-group>   
              </b-col>
            </b-row>

            <!-- OBJECTIF -->
            <b-row>
              <b-col sm="12" lg="6">            
                <b-form-group
                  id="input-group-7"
                  :label="formContent.formObjectif"
                  label-for="challenge-objectif"
                >
                  <b-form-input
                    id="challenge-objectif"
                    v-model="form.objective"
                    required
                    type='number'
                    :placeholder="formContent.formObjectifPlaceholder"
                  ></b-form-input>
                </b-form-group> 
              </b-col>
            </b-row>
         </b-form>    
        </b-overlay>      
      </div>



      <template v-slot:modal-footer>
          <b-button
          @click="closeMe()"
          class="btn-cancel"
          >
            {{formContent.formBtCancel}}
          </b-button>


          <b-button
            @click="newChallenge ? addChallenge() : modifyChallenge()"
            class="btn-challenges"
            :class="{disabled:isLoading}"
            :disabled="!isDisable()"
          >
            {{btAdd}}
          </b-button>


      </template>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from '../../../services/ApiService'
import ApiAuthenticationService from '../../../services/ApiAuthenticationService'
import CustomSelect from '../select/CustomSelect';
//
let selectedId='';

export default {
  name: "FormChallenge",
  components: {
    CustomSelect    

  },
  data() {
    return {
      theTitle:'',
        showMe: true, // show or not  the loading
        newChallenge:true, // params if new challenge or updated
        catDisabled: false,
        criteriaDisabled:false,
        form: { // form with all the necessary infos
          title: '',
          cat: '',
          criteria: '',
          startDate: '',
          endDate: '',
          objective: null,
          checked: [],
          theChallenge:'',
          theCategoriesList:'',
          theCriteriaList:'',
        },
        btAdd:'', // InnerHtml in button
        optionsDefault:'', // Default text for select category
        criteriaDefault:'', // Default text for select criteria
        cat: [], //CAT array form custom select
        criteria: [], //CRITERIA array form custom select
        isLoading:true, //IS LOADNG or not for add disable bt
        reference: '',
        catId: '',
    }
  },

  computed: {
    ...mapGetters([
        'getGeneral',
        'getChallengeUpdated'
    ]),
    nameState() {
      if(this.form.title){
        return this.form.title.length > 2 ? true : false
      } else{
        return false;
      }
    },   
    stateStartDate() {
      if(this.form.startDate){
        return this.form.startDate.length > 0 ? true : false
      } else{
        return false;
      }
    },   
    stateEndDate() {
      if(this.form.endDate){
        return this.form.endDate.length > 0 ? true : false
      }  else{
        return false;
      }    
    }    
  },
  created (){
    this.formContent = this.getGeneral;
    this.createChallenge();
  },
  methods:{

      onSubmit(evt) {
        evt.preventDefault()
        // alert(JSON.stringify(this.form))
      },

      //AFFICHAGE DU TOAST
      makeToast(variant = null) {
        if(variant == 'success'){
          this.$bvToast.toast('Le challenge a été créé', {
            title: `Enregistrement challenge`,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          })  
        } else if(variant == 'error'){
          this.$bvToast.toast('Une erreur est survenu, veuillez ré-essayer.', {
            title: `Enregistrement challenge`,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          }) 
        } else if(variant == 'info'){
          this.$bvToast.toast('Le challenge a été mis à jour.', {
            title: `Enregistrement challenge`,
            variant: 'success',
            solid: true,
            toaster:'b-toaster-top-center'
          }) 
        }

  
      },

      onReset() {
        // Reset our form values
        this.form.title = '';
        this.form.startDate = '';
        this.form.objective = '';
        this.form.endDate = '';
        this.theCategoriesList = [];
        this.theCriteriaList = [];
        this.form.startDate = '';
        this.form.endDate = '';
        this.cat = [];
        this.criteria = [];
        this.optionsDefault = '';
        this.criteriaDefault = '';
        this.show = false;
        this.$nextTick(() => {
          this.show = true
        })
      },

      //CLOSE THE POPUP
      closeMe(){
        this.$root.$emit('bv::hide::modal', 'form-challenge');
      }, 

      //event @click to add new challenge
      async addChallenge(){
        if(this.nameState && this.stateStartDate && this.stateEndDate){
          this.showMe = true;
          let theNewChallenge = await ApiService.getChallengeApi().post(ApiAuthenticationService.getCurrentUser().id,this.formatForm());
          if(theNewChallenge.status !== 400){
              this.showMe = false;
              this.makeToast('success');
              this.$emit('reload');
              this.$root.$emit('bv::hide::modal', 'form-challenge');
            }else{
              this.makeToast('error');
          }
        }
      },  
      
      //event @click to modify a challenge
      async modifyChallenge(){
        if(this.nameState && this.stateStartDate && this.stateEndDate){
          this.showMe = true;
          let theNewChallenge = await ApiService.getChallengeApi().patch(ApiAuthenticationService.getCurrentUser().id,this.getChallengeUpdated,this.formatForm());
          if(theNewChallenge.status !== 400){
              this.showMe = false;
              this.$emit('reload');
              this.closeMe();
              this.onReset();
              this.$store.dispatch('setChallengeUpdated','');
              this.makeToast('info');
            }else{
              this.makeToast('error');
          }
        }        
      },  

      //object with all the informations
      formatForm(){
        let info = {
          title     : this.form.title,
          reference : this.reference.toUpperCase(),
          categorie : this.catId,
          criteria  : this.criteriaDefault,
          startDate : this.form.startDate,
          endDate   : this.form.endDate,
          objective : this.form.objective,
        };
        return info;
      },
      
      //Toggle buttons REFERENCES
      toggleButtons(e){
        const buttons = document.querySelectorAll('.btn-modal');
        buttons ? buttons.forEach(button => button.classList.remove('select')) : '';
        e.currentTarget.classList.add('select');
        this.reference = e.currentTarget.innerHTML;
        this.updateCategories(e.currentTarget.getAttribute('data-value'));
      },

      //Event when change category select
      displayToKey ($e){
        //AS SOON AS A LIST IS SELECTED -> SAVE THE CURRENT ID IN THE STORE
        this.optionsDefault = $e;
        if(this.optionsDefault!='' && this.optionsDefault != undefined){
          selectedId = this.theCategoriesList.find(element => element.name == $e);
          this.updateCriteria(selectedId.id);
          this.catId =  selectedId.id;
        }
      },  

      //Event when change criteria select
      displayCriteria ($e){
        //AS SOON AS A LIST IS SELECTED -> SAVE THE CURRENT ID IN THE STORE
        this.criteriaDefault = $e;
      },  

      //function when call new challenge
      createChallenge (){
        this.newChallenge = true;
        this.theTitle = this.formContent.formModalTitle;
        this.btAdd = this.formContent.formBtCreate;
        this.onReset();
        this.showMe = false;
        this.isLoading = false;
      },  
      //CHECK IF INPUTS : TITLE, STARTDATE AND ENDDATE ARE NOT EMPTY
      isDisable(){
        return this.nameState && this.stateStartDate && this.stateEndDate;
      },

      //function to put inside input form the challenge informations
      async putInfo(){
        let promises = [];
        this.newChallenge = false;
        this.showMe = true;
        this.isLoading = true;
        this.onReset();
        //
        this.theTitle  = this.formContent.modifyEvent;
        this.btAdd = this.formContent.modify;
        //
        this.theChallenge = await ApiService.getChallengeApi().getDetails(ApiAuthenticationService.getCurrentUser().id,this.getChallengeUpdated);
        this.theChallenge = this.theChallenge.data;
        this.form = this.theChallenge;
        //
        let target = null;
        //
        switch (this.form.reference){
          case 'VIE':
            target = document.querySelector('.vie');
            break;
          case 'DOMMAGE':
            target = document.querySelector('.dommage')
            break;
          case 'QUALITE':
            target = document.querySelector('.qualite')
            break;
        }
        target && target.classList.add('select');
        this.reference = target.innerHTML;
        /////////////////////////////
        /*promises.push(ApiService.getChallengeApi().getCategoriesList(this.form.reference).then((data) => {
          this.theCategoriesList = data;
          this.theCategoriesList = this.theCategoriesList.data;
          const catChoose = this.theCategoriesList.find(element => element.id == this.form.categorie );
          if(catChoose != undefined){
            this.catId = this.form.categorie;
            this.theCategoriesList.map(element => {element.name && this.cat.push(element.name)});
            this.optionsDefault = this.cat.find(element => element == catChoose.name);
          }
        }));
        promises.push(ApiService.getChallengeApi().getCriterionList(this.form.categorie).then((data) => {
          this.theCriteriaList = data.data;
          this.theCriteriaList.map(element => {this.criteria.push(element.name)});
        }));*/
        this.criteriaDefault = this.form.criteria;
        this.showMe = false;
        this.isLoading = false;
        await Promise.all(promises);
      },


      //When change the select category (call api)
      async updateCategories(target){
        this.isLoading = true;
        this.catDisabled = true;
        this.criteriaDisabled = true;
        this.cat = this.criteria = this.theCriteriaList = [];
        this.optionsDefault = this.criteriaDefault = '';          
        //
        this.theCategoriesList = await ApiService.getChallengeApi().getCategoriesList(target.toUpperCase());
        this.theCategoriesList = this.theCategoriesList.data;
        //
        this.theCategoriesList.map(element => {this.cat.push(element.name)});
        this.optionsDefault = this.formContent.btChoose;  
        //    
        this.isLoading = false;
        this.catDisabled = false;     
      },

      //When change the select criteria (call api)
      async updateCriteria(target){
        this.isLoading = true;
        this.criteria = this.theCriteriaList = [];        
        this.theCriteriaList = await ApiService.getChallengeApi().getCriterionList(target);
        this.theCriteriaList = this.theCriteriaList.data;
        this.theCriteriaList.map(element => {this.criteria.push(element)});
        this.criteriaDefault =  this.formContent.btChoose;
        //  
        this.isLoading = false;
        this.criteriaDisabled = false;
      },

  },

  watch: {
      // Watch if getChallenged updated so open modify content
      getChallengeUpdated(){
          this.getChallengeUpdated !== '' ? this.putInfo() : this.createChallenge() ;
      },      
  },   
}
</script>

